import React, { Component } from 'react';
import T from 'components/common/translations/Translate';

class HomepageContent extends Component {
  render() {
    return (
      <div>
        <h2><T>content.homepage.title</T></h2>
        <p><T>content.homepage.content</T></p>
      </div>
    );
  }
}

export default HomepageContent;
